<template>
    <div>
        <loading-component :value="loading"/>
        <v-container class="mt-1 pt-0">
            <v-toolbar flat color="white mb-0">
                <v-toolbar-title>Salary Reports</v-toolbar-title>
                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>

                <v-menu
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-bottom="-24"
                        max-width="290px"
                        style="margin: 10px"
                >
                    <v-text-field
                            slot="activator"
                            label="Choose month"
                            v-model="date"
                            append-icon="today"
                            readonly
                    ></v-text-field>
                    <v-date-picker
                            v-model="date"
                            type="month"
                            label="Pick Date"
                    />
                </v-menu>  
                <v-btn  color="primary" dark class="mb-2 refresh-btn" @click='regenerateAllSalaries()'>Generate <v-icon>loop</v-icon></v-btn>
                <v-btn  color="primary" dark class="mb-2" @click='getData()'>Refresh</v-btn>

            </v-toolbar>

            <v-data-table :headers="headers" :rows-per-page-items="[100]" :items="formattedReport" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.salary_id }}</td>
                    <td class="text-xs-left">{{ props.item.employee_name }}</td>
                    <td class="text-xs-left">{{props.item.salary }}</td>
                    <td class="text-xs-left">
                        <span :class="props.item.OVERTIME > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">{{(props.item.OVERTIME) ? props.item.OVERTIME : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.DISCOUNT > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">
                            {{ props.item.DISCOUNT ? props.item.DISCOUNT : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.LATENESS > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">
                            {{ props.item.LATENESS ? props.item.LATENESS : "-" }}
                        </span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.EXTRA_HOURS > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.EXTRA_HOURS ? props.item.EXTRA_HOURS : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.LEAVE > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">{{ props.item.LEAVE ? props.item.LEAVE : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.GENERAL_HOLIDAY > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.GENERAL_HOLIDAY ? props.item.GENERAL_HOLIDAY : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.PENALTY > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.PENALTY ? props.item.PENALTY : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.BONUS > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.BONUS ? props.item.BONUS : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.SALARY_ADVANCE > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.SALARY_ADVANCE ? props.item.SALARY_ADVANCE : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.TOTAL > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.TOTAL ? props.item.TOTAL : "-" }}</span>
                    </td>
                    <td class="text-xs-left actions">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                 <v-icon  @click='showDetails(props.item)' v-bind="attrs" v-on="on">info</v-icon>
                            </template>
                            <span>More Details</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                 <v-icon @click='regenrateSalary(props.item)' v-bind="attrs" v-on="on">loop</v-icon>
                            </template>
                            <span>Regenerate Salary</span>
                        </v-tooltip>
                        
                    </td>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "AllSalaryReports",
        components: {ChooseDate, LoadingComponent},
        props: {
        },
        data() {
            return {
                date: null,//moment().format('YYYY-MM'),
                detailedReport: [],
                loading: false,
                headers: [
                    {text: 'Salary ID', value: 'salary_id', sortable: false},
                    {text: 'Employee', value: 'employee_name', sortable: false},
                    {text: 'Salary', value: 'salary', sortable: false},
                    {text: 'Overtime', value: 'OVERTIME', sortable: false},
                    {text: 'Discount', value: 'DISCOUNT', sortable: false},
                    {text: 'Lateness', value: 'LATENESS', sortable: false},
                    {text: 'Extra Hours', value: 'EXTRA_HOURS', sortable: false},
                    {text: 'Leave', value: 'LEAVE', sortable: false},
                    {text: 'General Holiday', value: 'GENERAL_HOLIDAY', sortable: false},
                    {text: 'Penalty', value: 'PENALTY', sortable: false},
                    {text: 'Bonus', value: 'BONUS', sortable: false},
                    {text: 'Salary Advance', value: 'SALARY_ADVANCE', sortable: false},
                    {text: 'Net Salary', value: 'TOTAL', sortable: false},
                    {text: 'Actions', value: 'actions', sortable: false },
                ],
                formattedReport: []
            }
        },
        mounted() {
            this.getData();
        },
        watch: {
            date: {
                handler() {
                    this.getData();
                }
            }
        },
        methods: {
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                if (this.date) params.append('date', this.date);
                this.axios.get(this.api.ACTIONS.ALL_SALARY_REPORT, {params})
                    .then((res) => {
                        if(res.data.data){
                            this.detailedReport = res.data.data;
                            if(!this.date){
                                let latestMonthDate = Object.values(this.detailedReport)[0].salary_report_date;
                                // get the salary report date and add a month to it (it would be sub monthed in the back)
                                latestMonthDate = moment(latestMonthDate).add(1, 'M').format('YYYY-MM')
                                this.date = latestMonthDate; 
                            }
                            this.formatReport();
                        }       
                    }).catch(
                    ({response}) => {
                        if (response && response.data && response.data.message){
                            this.formattedReport = [];
                            // when load for the fisrt time and there is no latest salary report
                            if(response.status == 400 && !this.date){ 
                                this.date = moment().format('YYYY-MM');
                            }
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        }   
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Error Happened", 'red');
                            console.log(response);
                        }
                    }
                ).finally(() => {
                    this.loading = false;
                });
            },

            setDate(){
                this.axios.get(this.api.ACTIONS.ALL_SALARY_REPORT, {params})
                    .then((res) => {   
                    }
                    ).catch(
                    ({response}) => {
                    }
                ).finally(() => {
                });
            },

            formatReport() {
                this.formattedReport = Object.values(this.detailedReport);
            }, 
            showDetails(item){
                this.$router.push({ 
                    path: '/salary_reports', 
                    query: {
                        date: this.date, 
                        user_id: item.user_id, 
                        enable_employee_choose: false, 
                        regenrate_option: true 
                    }
                })
            }, 
            regenrateSalary(item){
                this.loading = true;
                const params = new URLSearchParams();
                params.append('salary_report_id', item.salary_id);
                this.axios.get(this.api.ACTIONS.REGENERATE_REPORT, {params})
                    .then((res) => {
                        if(res.data.data){    
                            const updatedReport =  Object.values(res.data.data);
                            item.BONUS = updatedReport[0].BONUS;
                            item.DISCOUNT = updatedReport[0].DISCOUNT;
                            item.EXTRA_HOURS = updatedReport[0].EXTRA_HOURS;
                            item.GENERAL_HOLIDAY = updatedReport[0].GENERAL_HOLIDAY;
                            item.LATENESS = updatedReport[0].LATENESS;
                            item.LEAVE = updatedReport[0].LEAVE;
                            item.OVERTIME = updatedReport[0].OVERTIME;
                            item.SALARY_ADVANCE = updatedReport[0].SALARY_ADVANCE;
                            item.TOTAL = updatedReport[0].TOTAL;
                            item.PENALTY = updatedReport[0].PENALTY;
                            item.salary = updatedReport[0].salary;
                            // console.log(item);
                            // const reportIndex = this.formattedReport.findIndex(elem => elem.salary_id === item.salary_id);
                            // // console.log(this.formattedReport[reportIndex]);
                            // this.formattedReport[reportIndex] = updatedReport;
                            // console.log(this.formattedReport);
                        }
                    }).catch(
                    ({response}) => {
                        if (response && response.data && response.data.message){
                            this.formattedReport = [];
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        }   
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Error Happened", 'red');
                            console.log(response);
                        }
                    }
                ).finally(() => {
                    this.loading = false;
                });
            }, 

            regenerateAllSalaries(){
                this.loading = true;
                const params = new URLSearchParams();
                if (this.date) params.append('date', this.date);
                this.axios.get(this.api.ACTIONS.REGENERATE_ALL_REPORTS, {params})
                    .then((res) => {
                        this.detailedReport = res.data.data;
                        this.formatReport();
                    }).catch(
                    ({response}) => {
                        if (response && response.data && response.data.message){
                            this.formattedReport = [];
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        }   
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Error Happened", 'red');
                            console.log(response);
                        }
                    }
                ).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>
    .refresh-btn{
        margin-left: auto;
    }
    .actions i{
        display: inline;
    }
</style>
